(function () {
  'use strict';
  angular.module('crewSchedule').controller('AddOperationRemarksCtrl',addOperationRemarksCtrl)

  function addOperationRemarksCtrl(modalParams, MessageService, PopupManager,$uibModalInstance, CrewingHelper) {

    var vm=this;
    vm.crewScheduleBlockId = modalParams.crewScheduleBlockId;
    vm.remarks = null;


    vm.submitOperationRemarks=function () {

      updateRemarks();

    };


    function updateRemarks() {
      let param = {
        "crewScheduleBlockId": vm.crewScheduleBlockId,
        "remarks": vm.remarks
      };

      CrewingHelper.convertBackToSick(param,
        function(response) {
          console.log(response);
          MessageService.success(MessageService.MESSAGES.CREWING.CONVERTING_BACK_TO_SICK_SUCCESS);
        },
        function(error) {
          console.log(error);
          MessageService.error(MessageService.MESSAGES.CREWING.CONVERTING_BACK_TO_SICK_FAILED);
        }
      );

      $uibModalInstance.close(modalParams.close);

    }


    vm.closeRemarksPopup = function() {
      PopupManager.closeModal('SWO_CONVERTION_REMARKS');
    }





  }

}());
